import React, { CSSProperties } from 'react'
import "./Loader.css"
interface Props {
  style?: CSSProperties
}
export default function Loader ({ style }: Props) {
  return (
    <div className="loader loader-1" style={style}>
      <div className="loader-outter"></div>
    </div>
  )
}

Loader.defaultProps = {
  style: {}
}
